import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllStudents(payload) {
  try {
    yield put(actions.studentLoading(true));
    const result = yield call(api.getAllStudents, payload);
    yield put(actions.getAllStudentsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllStudentsFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}

function* getAllActiveStudents(payload) {
  try {
    yield put(actions.studentLoading(true));
    const result = yield call(api.getAllActiveStudents, payload);
    yield put(actions.getAllActiveStudentsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllActiveStudentsFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}
function* approveStudent({ payload }) {
  try {
    yield put(actions.studentLoading(true));
    const result = yield call(api.approveStudent, payload);
    yield put(actions.approveStudentSuccess(result.data));
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.approveStudentFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}

function* rejectStudent({ payload }) {
  try {
    yield put(actions.studentLoading(true));
    const result = yield call(api.rejectStudent, payload);
    toast.success("Done Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.rejectStudentFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}
function* addBulkStudent({ payload }) {
  try {
    yield put(actions.studentLoading(true));
    yield call(api.addBulkStudent, payload);
    toast.success("Students Added Successfully");
  } catch (error) {
    toast.error("Something Wrong");
    yield put(actions.addBulkStudentFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}

function* createStudent({ payload }) {
  try {
    yield put(actions.studentLoading(true));
    const result = yield call(api.createStudents, payload?.formData);
    yield put(
      actions.createStudentSuccess({
        data: result.data,
      })
    );
    payload?.action && payload?.action();

    toast.success("Created Successfully");
  } catch (error) {
    yield put(actions.createStudentFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}

function* editStudent({ payload }) {
  try {
    yield put(actions.studentLoading(true));
    const result = yield call(api.editStudents, payload);
    yield put(
      actions.editStudentSuccess({
        data: result.data.data,
      })
    );
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.editStudentFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}
function* deleteStudent({ payload }) {
  try {
    yield put(actions.studentLoading(true));
    yield call(api.deleteStudent, payload);
    toast.success("Deleted Successfully");
  } catch (error) {
    yield put(actions.deleteStudentFail());
  } finally {
    yield put(actions.studentLoading(false));
  }
}
export default function* SuperadminStudentsSaga() {
  yield takeLatest(Types.GET_SUPERADMIN_STUDENTS_REQUEST, getAllStudents);
  yield takeLatest(Types.CREATE_SUPERADMIN_STUDENT_REQUEST, createStudent);
  yield takeLatest(Types.EDIT_SUPERADMIN_STUDENT_REQUEST, editStudent);
  yield takeLatest(Types.DELETE_SUPERADMIN_STUDENT_REQUEST, deleteStudent);

  yield takeLatest(
    Types.GET_SUPERADMIN_ACTIVE_STUDENTS_REQUEST,
    getAllActiveStudents
  );

  yield takeLatest(Types.APPROVE_SUPERADMIN_STUDENT_REQUEST, approveStudent);
  yield takeLatest(Types.REJECT_SUPERADMIN_STUDENT_REQUEST, rejectStudent);
  yield takeLatest(Types.SUPERADMIN_ADD_BULK_STUDENT_REQUEST, addBulkStudent);
}
